import React from 'react';
import { Spinner } from '@bringg/react-components';
import './loader.scss';

const Loader = () => {
	return (
		<div className="routes-planner-loader">
			<Spinner className="routes-planner-spinner" />
		</div>
	);
};

export default Loader;
